import { z } from "zod";
import { searchDateFormParamsSchema } from "@core/components/form/FormDateArrange/types";
import { pagingFormSchema } from "@core/components/paging/type";
import { ipInputFormSchema } from "@features/management/pages/IpHistory/FormInputIp";

/**
 * [날짜] 검색 파라미터
 */

// 파라미터는 optional
export const dateSearchParamSchema = z.object({
  startDate: searchDateFormParamsSchema.shape.startDate.optional(),
  endDate: searchDateFormParamsSchema.shape.endDate.optional(),
  dateRadioValue: searchDateFormParamsSchema.shape.dateRadioValue.optional(),
});

export type DateSearchParams = z.infer<typeof dateSearchParamSchema>;

/**
 * [페이지] 검색 파라미터
 */

// 파라미터는 optional
export const pageSearchParamSchema = z.object({
  page: pagingFormSchema.shape.page.optional()
});

export type PageSearchParams = z.infer<typeof pageSearchParamSchema>;

/**
 * [날짜 + 페이지] 검색 파라미터
 */
export const datePageSearchParamsSchema = dateSearchParamSchema.extend(pageSearchParamSchema.shape);
export type DatePageSearchParams = z.infer<typeof datePageSearchParamsSchema>;

/**
 * IP 검색 파라미터
 */

// 파라미터는 optional
export const ipSearchParamSchema = z.object({
  ip: ipInputFormSchema.shape.ip.optional(),
});

export type IpSearchParams = z.infer<typeof ipSearchParamSchema>;

/**
 * [IP + 날짜 + 페이지] 검색 파라미터
 */
export const ipDatePagingSearchParamsSchema = ipSearchParamSchema.extend(datePageSearchParamsSchema.shape);
export type IpDatePagingSearchParams = z.infer<typeof ipDatePagingSearchParamsSchema>;
